import $ from 'jquery';

/**
 * Sidebar Class
 * Includes some basic required sidebar functionality
 */
class Sidebar {
    /**
     * Initilization Function
     * @returns {void}
     */
    init() {
        this.clickEventHandler();
    }

    /**
     * Handle click events
     * @returns {void}
     */
    clickEventHandler() {
        // Toggle open/close menu on click
        $(document).on('click', (e) => {
            const $target = e.target;
            const $parent = $($target).parent();

            if ($($target).hasClass('fa-caret-down') || $($target).hasClass('fa-caret-up')) {
                $($target).toggleClass('fa-caret-down');
                $($target).toggleClass('fa-caret-up');
                $('.sidebar .content').slideToggle();
            } else if ($($parent).hasClass('fa-caret-down') || $($parent).hasClass('fa-caret-up')) {
                $($parent).toggleClass('fa-caret-down');
                $($parent).toggleClass('fa-caret-up');
                $('.sidebar .content').slideToggle();
            }
        });

        // Show menu on resize to desktop
        $(window).resize(() => {
            if ($( window ).width() >= 720 && $('.sidebar .content').attr("style")) {
                $('.sidebar .content').removeAttr("style")
            }
        });
    }
}

export default Sidebar;
